import React from 'react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function FinalCTA() {
  const handleCheckoutClick = () => {
    trackInitiateCheckout();
  };
  return <section className="bg-gradient-to-b from-brand-dark to-[#1a0508] py-20 px-5" data-id="element-68">
      <div className="max-w-[860px] mx-auto" data-id="element-69">
        <div className="max-w-[680px] mx-auto text-center" data-id="element-70">
          <h3 className="text-[clamp(24px,4vw,32px)] font-black text-white mb-8 uppercase tracking-wide" data-id="element-71">
            ¿Qué clase de persona eres tú?
          </h3>
          <div className="grid grid-cols-2 gap-5 mb-10 sm:grid-cols-1" data-id="element-72">
            <div className="bg-brand-dark2 border border-brand-red/30 rounded-2xl p-6 text-center" data-id="element-73">
              <div className="text-[32px] mb-3" data-id="element-74">😰</div>
              <h4 className="text-[15px] font-extrabold text-white mb-2.5" data-id="element-75">
                El primero cierra esta página
              </h4>
              <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-76">
                Se dice que "lo piensa." La próxima semana llega igual — mismas
                bills, mismo estrés, mismo miedo de revisar la cuenta.
              </p>
            </div>

            <div className="bg-brand-dark2 border border-brand-green/30 rounded-2xl p-6 text-center" data-id="element-77">
              <div className="text-[32px] mb-3" data-id="element-78">💪</div>
              <h4 className="text-[15px] font-extrabold text-white mb-2.5" data-id="element-79">
                El segundo actúa hoy
              </h4>
              <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-80">
                No porque tenga todo resuelto. Sino porque entiende que cada
                semana sin sistema tiene un costo real.
              </p>
            </div>
          </div>

          <p className="text-[clamp(18px,3vw,24px)] font-black text-white mb-3 leading-[1.4]" data-id="element-81">
            "El control financiero no llega cuando el ingreso mejora.
            <br data-id="element-82" />
            Llega cuando tienes un sistema que funciona con el ingreso que ya
            tienes."
          </p>
          <p className="text-base text-brand-gray mb-9 italic" data-id="element-83">
            "El mejor momento para empezar era hace seis meses. El segundo mejor
            momento es hoy."
          </p>

          <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="btn-buy-main inline-block w-full max-w-[480px] text-white no-underline text-[clamp(16px,3vw,22px)] font-black py-5 px-7 rounded-xl uppercase tracking-[1px] transition-all duration-300 shadow-[0_8px_30px_rgba(230,57,70,0.5)] text-center cursor-pointer border-none hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(230,57,70,0.6)]" data-id="element-84">
            🔥 SÍ — QUIERO EL SISTEMA POR $6.39
            <span className="block text-xs font-normal opacity-85 mt-1 normal-case tracking-normal" data-id="element-85">
              Acceso inmediato · PDF descargable · 30 días de garantía
            </span>
          </a>

          <div className="flex justify-center gap-5 flex-wrap mt-5 text-xs text-brand-gray" data-id="element-86">
            <span className="flex items-center gap-1" data-id="element-87">🔒 Pago 100% seguro</span>
            <span className="flex items-center gap-1" data-id="element-88">
              Visa · Mastercard · PayPal
            </span>
          </div>
        </div>
      </div>
    </section>;
}